import Swiper from 'swiper';

export default class Carousel {
	constructor(el) {
		this.swiperEl = el.querySelector('[data-swiper]');
		this.prevEl = el.querySelector('[data-swiper-prev]');
		this.nextEl = el.querySelector('[data-swiper-next]');
		this.nextEl.addEventListener('click', () => this.swiper.slideNext());
		this.prevEl.addEventListener('click', () => this.swiper.slidePrev());

		this.swiper = new Swiper('.swiper', {
			speed: 500,
			slidesPerView: 1,
			spaceBetween: 8,
		});

		this.swiper.on('slideChange', () => {
			if (this.swiper.isBeginning) {
				this.prevEl.classList.add('is-inactive');
			} else {
				this.prevEl.classList.remove('is-inactive');
			}

			if (this.swiper.isEnd) {
				this.nextEl.classList.add('is-inactive');
			} else {
				this.nextEl.classList.remove('is-inactive');
			}
		});
	}
}
